import { Validators } from '@angular/forms';

import { EventResult, FocusContainerDto } from '../../coaching-base/general';
import { TranslationKeyMap } from '../coaching-observation.i18n';
import { CmpsFormField, CmpsFormFields } from '../experimental.form';
import { tagGroupFormValueModelTransformer } from '../observation-tag-group/tag-group.observation.form';

import { ObservationFormValue } from './observation-form-value.model';

export interface ObservationFormFields extends CmpsFormFields {
    DELIVERY_TYPE: CmpsFormField;
    START_TIME: CmpsFormField;
    DURATION: CmpsFormField;
    TAG_GROUPS: CmpsFormField;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ObservationFormFields: ObservationFormFields = {
    DELIVERY_TYPE: {
        name: 'deliveryType',
        label: TranslationKeyMap._9419_TYPE_,
        validators: [Validators.required],
        validationMsgs: {
            required:
                TranslationKeyMap._640__FIELD_LABEL__IS_A_REQUIRED_FIELD__PLEASE_ENTER_A__FIELD_LABEL_,
        },
    },
    START_TIME: {
        name: 'startTime',
        label: '',
        validators: [Validators.required],
        validationMsgs: {
            required:
                TranslationKeyMap._9712_PLEASE_CHECK_THE_ENTERED_OBSERVATION_DATE_,
            dateInvalid: TranslationKeyMap._9512_INVALID_DATE_,
            dateMax:
                TranslationKeyMap._9713_THE_OBSERVATION_DATE_CANNOT_BE_IN_THE_FUTURE_,
        },
    },
    DURATION: {
        name: 'duration',
        label: '',
        validators: [Validators.required],
        validationMsgs: {
            // TODO adjust for variable interpolation after textId is assigned
            required: TranslationKeyMap._9714_DURATION_RANGE,
            min: TranslationKeyMap._9714_DURATION_RANGE,
            max: TranslationKeyMap._9714_DURATION_RANGE,
        },
    },
    TAG_GROUPS: {
        name: 'tagGroups',
        label: '',
    },
};

export function observationFormValueTransformer(
    model1: EventResult,
    model2: FocusContainerDto[],
): ObservationFormValue {
    if (!model1) {
        return null;
    }
    return {
        deliveryType: model1.deliveryTypeId,
        startTime: model1.startTime,
        duration: model1.duration,
        tagGroups: (model2 || []).map(tagGroupFormValueModelTransformer),
    };
}
